import { NativeEventEmitter } from 'react-native'
import { StackActions } from '@react-navigation/core'

import { navigationRef } from './RootNavigation'
import { ROUTES } from 'app/routes/types'
import { NavigationParams } from 'app/models/Navigation'

const rnNavigation = ({
  name,
  deeplink = null,
  params = null,
  replace = false,
}: NavigationParams) => {
  if (replace) {
    navigationRef.dispatch(StackActions.replace(name, params as object))
  } else
    navigationRef.navigate({
      name,
      params,
    } as never)
}

const openLink = (url: string) => {
  window?.open(url)
}

const finishCurrentActivity = () => {
  /**
   *  Not supported on dba web yet.
   *  No concept of finish current actity. This will be a  mocked empty function
   */
}

const goToHome = () => {
  navigationRef.reset({
    index: 0,
    routes: [{ name: ROUTES.DASHBOARD }],
  })
}

const replaceCurrentActivity = (callback: Function) => {
  callback()
}

const clearNavigationBackStack: Function | undefined = undefined

const initializeEventEmitter = (): NativeEventEmitter | undefined => undefined

export {
  rnNavigation,
  openLink,
  finishCurrentActivity,
  goToHome,
  replaceCurrentActivity,
  clearNavigationBackStack,
  initializeEventEmitter,
}
